import React, { lazy } from "react";
// signin pages
const LoginPage = lazy(() => import("pages/Login"));
const ForgotPasswordPage = lazy(() => import("pages/Login/ForgotPassword"));
const ResetPasswordPage = lazy(() => import("pages/Login/ResetPassword"));
// admin routes
const DashboardPage = lazy(() => import("pages/Dashboard"));
// teacher
const TeacherPage = lazy(() => import("pages/Teacher"));
const EditTeacherPage = lazy(() => import("pages/Teacher/EditTeacher"));
// student
const StudentPage = lazy(() => import("pages/Student"));
const EditStudentPage = lazy(() => import("pages/Student/EditStudent"));
// transaction
const PaymentTransactionPage = lazy(() => import("pages/PaymentTransaction"));
// profile
const UpdateProfilePage = lazy(() => import("pages/Profile/UpdateProfile"));
const ChangePasswordPage = lazy(() => import("pages/Profile/ChangePassword"));
// content pages
const ContentPageListPage = lazy(() => import("pages/ContentPage"));
const EditContentPage = lazy(() => import("pages/ContentPage/EditContentPage"));
// Admin Users
const AdminUserListPage = lazy(() => import("pages/AdminUser"));
const AddAdminUserPage = lazy(() => import("pages/AdminUser/AddAdminUser"));
const EditAdminUserPage = lazy(() => import("pages/AdminUser/EditAdminUser"));
// email notification
const EmailNotificationPage = lazy(() => import("pages/EmailNotification"));
// subscription list
const SubscriptionListPage = lazy(() => import("pages/Subscription"));
const AddSubscriptionPage = lazy(() => import("pages/Subscription/AddSubscription"));
const EditSubscriptionPage = lazy(() => import("pages/Subscription/EditSubscription"));
const SubscriptionTransactionPage = lazy(() => import("pages/SubscriptionTransaction"));
// mobile apps string
const MobileAppsStringPage = lazy(() => import("pages/MobileAppsString"));
const AddMobileAppsStringPage = lazy(() => import("pages/MobileAppsString/AddMobileAppsString"));
const EditMobileAppsStringPage = lazy(() => import("pages/MobileAppsString/EditMobileAppsString"));
//manage subscription
const ManageSubscriptionPage = lazy(() => import("pages/ManageSubscription"));

export const mainRoutes = {
  dashboard: { path: "/", element: <DashboardPage /> },
  teachers: { path: "/service-providers", element: <TeacherPage /> },
  editTeacher: { path: "/service-providers/edit/:id", element: <EditTeacherPage /> },
  students: { path: "/clients", element: <StudentPage /> },
  editStudent: { path: "/clients/edit/:id", element: <EditStudentPage /> },
  paymentTransactions: { path: "/payment-transactions", element: <PaymentTransactionPage /> },
  updateProfile: { path: "/update-profile", element: <UpdateProfilePage /> },
  changePassword: { path: "/change-password", element: <ChangePasswordPage /> },
  contentPage: { path: "/content-pages", element: <ContentPageListPage /> },
  editContentPage: { path: "/content-pages/edit/:id", element: <EditContentPage /> },
  adminUsers: { path: "/admin-users", element: <AdminUserListPage /> },
  addAdminUser: { path: "/admin-users/add", element: <AddAdminUserPage /> },
  editAdminUser: { path: "/admin-users/edit/:id", element: <EditAdminUserPage /> },
  subscriptions: { path: "/subscriptions", element: <SubscriptionListPage /> },
  addSubscription: { path: "/subscriptions/add", element: <AddSubscriptionPage /> },
  editSubscription: { path: "/subscriptions/edit/:id", element: <EditSubscriptionPage /> },
  subscriptionTransactions: { path: "/subscription-transactions", element: <SubscriptionTransactionPage /> },
  emailNotification: { path: "/email-notification", element: <EmailNotificationPage /> },
  mobileAppsString: { path: "/mobile-apps-string", element: <MobileAppsStringPage /> },
  addmobileAppsString: { path: "/mobile-apps-string/add", element: <AddMobileAppsStringPage /> },
  editmobileAppsString: { path: "/mobile-apps-string/edit/:id", element: <EditMobileAppsStringPage /> },
  manageSubscription: { path: "/manage-subscription", element: <ManageSubscriptionPage /> },
};

export const loginRoutes = {
  signin: { path: "/signin", element: <LoginPage /> },
  forgotPassword: { path: "/forgot-password", element: <ForgotPasswordPage /> },
  resetPassword: { path: "/reset-password", element: <ResetPasswordPage /> },
};

export const getUserHomePageRoute = () => {
  return mainRoutes.teachers.path; 
}